<template>
  <div class="home-container" :class="{ 'is-news': isNews, 'is-factory': isFactory }">
    <div class="header-wrap">
      <div class="header-container">
        <div class="header-logo" @click="linkPath('index')">
          <a class="logo-link"></a>
          <span class="logo-txt">探所电动</span>
        </div>

        <div class="header-nav">
          <span class="nav-link" @click="linkPath('index')">首页</span>
          <!-- <el-dropdown @command="handleCommand">
            <span class="nav-link">
              探所产品<i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="types">
                <div class="down-items">
                  <div class="down-item">
                    <span class="item-txt">探所2049</span>
                    <img class="item-img" src="../assets/home/icon_home_footer_01.png" />
                  </div>
                  <div class="down-item">
                    <span class="item-txt">探所平行时空</span>
                    <img class="item-img" src="../assets/home/icon_home_footer_03.png" />
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <el-popover
            placement="bottom"
            trigger="hover">
            <div class="down-items">
              <div class="down-item" @click="linkPath('bike')">
                <span class="item-txt">探所平行时空</span>
                <div class="img-wrap">
                  <img class="item-img" src="../assets/home/icon_home_footer_003.png" style="padding-top: 12px;" />
                </div>
              </div>
              <div class="down-item" @click="linkPath('types')">
                <span class="item-txt">探所2049</span>
                <div class="img-wrap">
                  <img class="item-img" src="../assets/home/icon_home_footer_01.png" style="width: 90%;" />
                </div>
              </div>
            </div>
            <span class="nav-link" slot="reference">
              探所产品<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <!-- <span class="nav-link" @click="linkPath('/types')">探所2049</span>
          <span class="nav-link" @click="linkPath('/bike')">探所Bike</span> -->
          <!-- <span class="nav-link" @click="linkPath('/store')">门店服务</span> -->
          <!-- <span class="nav-link" @click="linkPath('aboutUs')">关于我们</span> -->

          <el-popover
            popper-class="customize-popper"
            class="aaa"
            placement="bottom"
            trigger="hover">
            <div class="">
              <span class="customize-link" @click="linkPath('aboutUs')">关于我们</span>
              <span class="customize-link" @click="linkPath('factory')">智能工厂</span>
              <span class="customize-link" @click="linkPath('news')">新闻资讯</span>
            </div>
            <span class="nav-link" slot="reference">
              关于我们<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>

          <span class="nav-link" @click="linkPath('customerService')">服务支持</span>
        </div>

        <div class="header-reservation">
          <span class="reservation" @click="linkPeservation">预约试驾</span>
        </div>
      </div>
    </div>
    <!-- <router-view/> -->

    <div class="pre-load">
      <!-- <img src="../assets/icon_types_banner_01.png" /> -->
      <img class="banner-image" src="../assets/icon_bg_.jpg" />
      <img class="banner-image" src="../assets/icon_home_banner.png" />
      <img class="banner-image" src="../assets/home/icon_home_banner_002.png" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  // components: {
  //   HelloWorld
  // }
  props: {
    isNews: {
      type: Boolean,
      default: false
    },
    isFactory: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isAbout: false,
      isStore: false,
      lastScrollPosition: 0,
      wipeUp: false,
    }
  },
  mounted() {
    // const { path } = this.$route;
    // this.isAbout = path === '/about';
    // this.isStore = path === '/store';

    // --------绑定滚动事件
    // window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll);
    // this.timer = null;
  },
  methods: {
    handleScroll() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        console.log('currentScrollPosition', currentScrollPosition);
        if (currentScrollPosition > this.lastScrollPosition) {
          // 向下滑动
          console.log('向下滑动');
          this.wipeUp = true;
        } else {
          // 向上滑动
          console.log('向上滑动');
          this.wipeUp = false;
        }
        this.lastScrollPosition = currentScrollPosition;
      }, 500);
    },
    linkPath(type) {
      location.href = `${type}.html`;
    },
    linkPeservation() {
      location.href = 'reservation.html';
    },
    handleCommand() {},
  }
}
</script>
<style lang="less" scoped>
.home-container {
  position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 50px;
  background: url(../assets/icon_bg_.jpg) no-repeat center;
  &.is-news {
    background: #ffefdf;
  }
  &.is-factory {
    // background: url('../assets/about/icon_factory_bg.png') no-repeat center;
    // background-size: cover;
    // opacity: 0.5;
  }
  // .header-wrap {
  //   position: sticky;
  //   top: 0;
  //   z-index: 99;
  //   width: 100%;
  //   height: 50px;
  //   background: url(../assets/icon_bg_.jpg) no-repeat center;
  // }
  .header-container {
    // position: fixed;
    // width: 100%;
    // top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5%;
    height: 50px;
    // background: url(../assets/icon_bg_.jpg) no-repeat center;
    // background-size: 100% 60px;
    z-index: 999;
    &.is-about {
      background: #fff;
    }
    &.is-store {
    background: url(../assets/icon_store_header.png) no-repeat center;
    background-size: cover;
    }
    .header-logo {
      display: flex;
      .logo-link {
        width: 130px;
        height: 30px;
        background: url(../assets/icon_logo.png) no-repeat center;
        background-size: 98% 22px;
      }
      .logo-txt {
        line-height: 30px;
        padding-left: 26px;
        font-size: 22.05px;
        color: #1A1A1A;
        letter-spacing: 9.26px;
        text-align: center;
      }
    }
    .header-nav {
      flex: 1;
      max-width: 550px;
      display: flex;
      justify-content: space-between;
      .nav-link {
        // padding-right: 20px;
        padding: 0 10px;
        line-height: 30px;
        font-size: 18px;
        color: #1A1A1A;
        cursor: pointer;
      }
    }
    .header-reservation {
      width: 280px;
      display: flex;
      justify-content: flex-end;
      .reservation {
        width: 108px;
        height: 28px;
        line-height: 28px;
        border: 1px solid #1A1A1A;
        font-size: 18px;
        color: #1A1A1A;
        border-radius: 40px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .is-wipe-up {
    position: static;
    height: 0;
    overflow: hidden;
    transition: all 0.4s;
  }

  .pre-load {
    width: 0;
    height: 0;
    overflow: hidden;
  }
}
.down-items {
  display: flex;
  width: 300px;
  .down-item {
    flex: 1;
    cursor: pointer;
    &:first-child {
      .item-txt {
        border-right: 1px solid #666;
      }
    }
    .item-txt {
      letter-spacing: 0;
      display: block;
      line-height: 18px;
      font-size: 16px;
      color: #222;
      text-align: center;
    }
    .img-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 135px;
      height: 100px;
      .item-img {
        padding-top: 10px;
        width: 85%;
      }
    }
  }
}
</style>
<style lang="less">
.customize-popper.el-popover {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 120px;
  min-width: 120px;
  padding: 12px 0 0 0;
  .customize-link {
    display: block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    width: 100%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.5);
    font-size: 18px;
    color: #1A1A1A;
    cursor: pointer;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
